import { render, staticRenderFns } from "./RoomNotification.vue?vue&type=template&id=445a91f4&"
import script from "./RoomNotification.vue?vue&type=script&lang=js&"
export * from "./RoomNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('445a91f4')) {
      api.createRecord('445a91f4', component.options)
    } else {
      api.reload('445a91f4', component.options)
    }
    module.hot.accept("./RoomNotification.vue?vue&type=template&id=445a91f4&", function () {
      api.rerender('445a91f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Notification/RoomNotification.vue"
export default component.exports